<mat-card>
  <h2 translate>sidenav.menu.users.ownPassword</h2>
  <mat-card-content>
    <form [formGroup]="ownPasswordForm" (ngSubmit)="changePassword()">
      <mat-grid-list cols="16" rowHeight="10px">
        <mat-grid-tile colspan="6" rowspan="6">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>ownPassword.user</mat-label>
            <input
              id="userOwnPassword"
              #userOwnPassword
              formControlName="user"
              matInput
              type="text"
              autocomplete="off"
            />
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="10" rowspan="6">
          <!-- <mat-label class="user-name" fxFlex="100" translate>{{ userName }}</mat-label> -->
        </mat-grid-tile>

        <mat-grid-tile colspan="6" rowspan="6">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>ownPassword.password</mat-label>
            <input
              id="passwordOwnPassword"
              #passwordOwnPassword
              formControlName="password"
              matInput
              type="password"
              autocomplete="off"
            />
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="4" rowspan="6">
          <div fxFlex="100" class="new-pass-button">
            <button
              id="changePasswordOwnPassword"
              color="primary"
              type="submit"
              fxFlex="100"
              mat-flat-button
              [disabled]="searchButtonDisabled"
            >
              <mat-label translate>ownPassword.newPassword</mat-label>
            </button>
          </div>
        </mat-grid-tile>

        <mat-grid-tile colspan="16" rowspan="4">
          <div fxFlex="100" fxLayout="column" fxLayoutAlign="center start">
            <mat-checkbox
              id="checkWebServiceOwnPassword"
              color="accent"
              [checked]="checkedWS"
              (change)="checkedWS = !checkedWS"
              name="checkWebService"
              formControlName="checkWebService"
            >
              <span translate>ownPassword.webService</span>
            </mat-checkbox>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </form>
  </mat-card-content>
</mat-card>
